__turbopack_context__.v({
  "Break": "v2eRMq_Break",
  "Item": "v2eRMq_Item",
  "ItemChevron": "v2eRMq_ItemChevron",
  "Link": "v2eRMq_Link",
  "LinkActive": "v2eRMq_LinkActive",
  "LinkChevron": "v2eRMq_LinkChevron",
  "LinkChevronLeft": "v2eRMq_LinkChevronLeft",
  "LinkChevronRight": "v2eRMq_LinkChevronRight",
  "LinkDisabled": "v2eRMq_LinkDisabled",
  "List": "v2eRMq_List",
  "NewsListPage": "v2eRMq_NewsListPage",
  "Root": "v2eRMq_Root",
});
